import React from "react";
import IconArrowRight from "../icons/icon-arrow-right";
import Link from "next/link";
import IconArrowUp from "../icons/icon-arrow-up";
import Image from "next/image";
import { Marquee } from "../marquee";

const links = [
  {
    name: "About",
    href: "/about",
  },
  {
    name: "Menu",
    href: "/menu",
  },
  {
    name: "Gallery",
    href: "/gallery",
  },
  {
    name: "Review",
    href: "/#testimonials",
  },
  {
    name: "FAQ",
    href: "/about#faq",
  },
  {
    name: "Contact",
    href: "https://wa.me/8801830000233",
  },
];

const Footer = () => {
  return (
    <footer className="w-full pt-10 xl:pt-[200px] pb-10 bg-[url('/imgs/footer-bg.png')] bg-cover bg-center bg-no-repeat">
      <div className="w-full px-[30px] xl:px-20">
        <div className="w-full flex flex-col xl:flex-row items-start xl:items-center justify-between xl:gap-0 gap-8 py-[30px] lg:py-[63px] border-y-[1px] border-white/20">
          {/* Grid */}
          <div className="max-w-[628px] w-full grid grid-cols-1 lg:grid-cols-2 gap-y-6 md:gap-y-[35px] lg:gap-y-10 lg:gap-x-[35px]">
            <div>
              <p className="footer_title">Address :</p>
              <h3 className="footer_sub_title">
                27 C/A Faisal tower 2nd floor road- 52, Gulshan-2
              </h3>
              <a
                href=" https://maps.app.goo.gl/4mBtNUtSyeYsaxzx6"
                target="_blank"
                className="flex items-center gap-3 text-lg text-old-gold font-semibold mt-4 md:mt-[30px]"
              >
                View on map <IconArrowRight />
              </a>
            </div>
            <div>
              <p className="footer_title">Phone number :</p>
              <h3 className="footer_sub_title">
                <a href="tel:+8801830000233">+880 1830 000 233</a>
              </h3>
            </div>{" "}
            <div>
              <p className="footer_title">Restaurant hours :</p>
              <h3 className="footer_sub_title">
                Monday - Tuesday <br />
                11:00 AM - 2:00 AM
            
              </h3>
              <Link
                href="/about"
                className="flex items-center gap-3 text-lg text-old-gold font-semibold mt-4 md:mt-[30px]"
              >
                More info <IconArrowRight />
              </Link>
            </div>
            <div className="text-wrap">
              <p className="footer_title">Email :</p>
              <a
                href="mailto:arabianrestaurantalmajlis@gmail.com"
                className="footer_sub_title hover:text-old-gold"
              >
                arabianrestaurantalmajlis@gmail.com
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="grid grid-cols-3 gap-x-[30px] lg:gap-x-[70px] gap-y-5 xl:gap-y-10">
            {links.map((link) => (
              <Link
                key={link.name}
                href={link.href}
                className="text-lg md:text-[24px] lg:text-[35px] font-medium text-white hover:text-old-gold duration-300 ease-in-out"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* marquee */}
      <Marquee className="w-full flex items-center mt-5 lg:mt-10">
        <h1 className="shrink-0 text-[60.33px] lg:text-[156px] leading-[100%] font-bold text-semibold-lace uppercase font-unbounded">
          AlMajlis
        </h1>
        <div className="shrink-0 w-[117.86px] h-[60.33px] lg:h-[132px]">
          <Image
            src="/imgs/logo-lg.png"
            alt="logo"
            width={250}
            height={220}
            className="w-full h-full object-contain"
          />
        </div>
        <h1 className="shrink-0 text-[60.33px] lg:text-[156px] leading-[100%] font-bold text-semibold-lace uppercase font-unbounded">
          ARABIAN
        </h1>
        <div className="shrink-0 w-[117.86px] h-[60.33px] lg:h-[132px]">
          <Image
            src="/imgs/logo-lg.png"
            alt="logo"
            width={250}
            height={220}
            className="w-full h-full object-contain"
          />
        </div>
      </Marquee>

      <div className="w-full px-[30px] xl:px-20 flex lg:flex-row flex-col items-center gap-3 justify-between mt-10">
       <a href="https://faarns.com"> <p className="lg:order-1 order-2">@2025 <b>FAARNS</b>, all rights reserved</p></a>
        <Link
          href={"#"}
          className="lg:order-2 order-3 px-5 h-10 center rounded-[25px] border gap-3"
        >
          Back To Top <IconArrowUp />
        </Link>
        <div className="flex items-center lg:order-3 order-1">
          <p>Privacy Policy</p>
          <div className="w-[2px] h-6.5 bg-white mx-3"></div>
          <p>Terms & Conditions</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
